import React, { Component } from 'react';
import _ from 'lodash';
import Divisions from './Divisions';

class Circle extends Component {
    render() {
        var value = 360/this.props.units;
        var segments = _.times(this.props.units/2, (itr) => {
            return itr * value; 
        });
        if (this.props.units === 1) {
            segments = null;
        }
        return (
            <div 
                className="circle" 
                style={{
                    width: this.props.size + 'px',
                    height: this.props.size + 'px',
                    zIndex: this.props.round
                }}
                >
                { segments.map((segment) => (
                    <div 
                        key={segment}
                        className="segment" 
                        style={{
                            '--value': value,
                            '--offset': segment
                            }}/>
                ))}
            </div>
        )
    }
}

class Circles extends Component {
    render() {
        // var width = window.innerWidth;
        var width = 900/2;
        var unit = width/6;

        return (
            <div className="circle-wrapper">
                <Divisions />
                <Circle size={12*unit} round='1' units='64'/>
                <Circle size={11*unit} round='2' units='32'/>
                <Circle size={9*unit}  round='3' units='16'/>
                <Circle size={7*unit}  round='4' units='8'/>
                <Circle size={5*unit}  round='5' units='4'/>
                <Circle size={3*unit}  round='6' units='2'/>
                <Circle size={1.5*unit} round='7' units='1'/>
            </div>
        );
    }
}

export default Circles;